function Footer() {
  return (
    <footer>
      <p>
        &copy; 2026 UTS (Univision Technology Solutions). All rights reserved to
        their respective parent and subsidiary domains.
      </p>
    </footer>
  );
}

export default Footer;
